/* eslint-disable no-unused-expressions */
import {
  showSecondLayerAction,
  hideAction as hideSizeConfiguratorAction,
  setConfiguratorType,
  setValuesAction as setConfiguratorValues,
  showAction as showSizeConfiguratorAction,
  showExtendedAction as showExtendedSizeConfiguratorAction,
  setVisibleSectionsAction as setSizeConfiguratorVisibleSection,
  showSizeConfiguratorFromLayerAction,
  showFirstLayerAction,
} from '../../_flux/actions/catalog_configurator_actions';
import {
  showAction as showRegoLookupAction,
  showActionV2 as showRegoLookupActionV2,
  hideAction as hideRegoLookupAction,
  showFromConfiguratorAction,
} from '../../_flux/actions/rego_lookup_actions';
import {
  showAction as showVehicleConfiguratorAction,
  showActionV2 as showVehicleConfiguratorActionV2,
  hideAction as hideVehicleConfiguratorAction,
  showVehicleConfiguratorFromConfiguratorLayerAction,
} from '../../_flux/actions/vehicle_configurator_actions';
import CatalogFilterStore from '../../_flux/stores/catalog_configurator_store';
import { types as productTypes } from '../../_constants/product/types';
import { resetAllFilter } from '../configurator/reset_filters_after_change';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import TyreSizeConfiguratorFilterOptionsStore from '../../_flux/stores/configurator_filter_options_store/tyre';
import TyreMotoSizeConfiguratorFilterOptionsStore from '../../_flux/stores/configurator_filter_options_store/tyre_moto';
import { loadVehicleConfiguratorData } from '../../_modules/vehicle_configurator/get_vehicle_data';
import {
  hideVehicleNotProvidedLayerAction as hideVNPRegoAction,
  resetValuesAction as resetRegoAction,
} from '../../_flux/actions/rego_lookup_actions';
import {
  hideVehicleNotProvidedLayerAction as hideVNPVehicleAction,
  resetValuesAction as resetVehicleAction,
} from '../../_flux/actions/vehicle_configurator_actions';
import { loadVehicleConfiguratorMake } from '../../_modules/vehicle_configurator/get_make';

export function onOpenExtendedCmsSizeConfiguratorClick(productType, values) {
  setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
  resetAllFilter(productType);

  setConfiguratorType(productType);

  let filterOptionsStore = TyreSizeConfiguratorFilterOptionsStore.getState();
  if (productTypes.TYRE_MOTO === productType) {
    filterOptionsStore = TyreMotoSizeConfiguratorFilterOptionsStore.getState();
  }

  updateFilterOptionsAction(filterOptionsStore);
  hideRegoLookupAction();
  hideVehicleConfiguratorAction();
  showExtendedSizeConfiguratorAction(values);
}

export function onOpenDefaultLayerConfigurator() {
  const { pageOriginType } = CatalogFilterStore.getState();
  if (productTypes.TYRE_CAR === pageOriginType) {
    setConfiguratorValues(CatalogFilterStore.getState().backupValues);
  } else {
    setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
    resetAllFilter(productTypes.TYRE_CAR);
  }

  setConfiguratorType(productTypes.TYRE_CAR);
  updateFilterOptionsAction(TyreSizeConfiguratorFilterOptionsStore.getState());

  hideRegoLookupAction();
  hideVehicleConfiguratorAction();
  showSizeConfiguratorAction();
  showFirstLayerAction();
}

export function onOpenTyreSizeConfiguratorClick(isLayerButton = false) {
  const { pageOriginType } = CatalogFilterStore.getState();
  if (productTypes.TYRE_CAR === pageOriginType) {
    setConfiguratorValues(CatalogFilterStore.getState().backupValues);
  } else {
    setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
    resetAllFilter(productTypes.TYRE_CAR);
  }

  setConfiguratorType(productTypes.TYRE_CAR);
  updateFilterOptionsAction(TyreSizeConfiguratorFilterOptionsStore.getState());

  hideRegoLookupAction();
  hideVehicleConfiguratorAction();
  showSecondLayerAction();
  isLayerButton ? showSizeConfiguratorFromLayerAction() : showSizeConfiguratorAction();
}

export function onOpenMotoTyreSizeConfiguratorClick(isLayerButton = false) {
  const { pageOriginType } = CatalogFilterStore.getState();
  if (productTypes.TYRE_MOTO === pageOriginType) {
    setConfiguratorValues(CatalogFilterStore.getState().backupValues);
  } else {
    setSizeConfiguratorVisibleSection(['indexes', 'postcode', 'sizes']);
    resetAllFilter(productTypes.TYRE_MOTO);
  }

  setConfiguratorType(productTypes.TYRE_MOTO);
  updateFilterOptionsAction(TyreMotoSizeConfiguratorFilterOptionsStore.getState());

  hideRegoLookupAction();
  hideVehicleConfiguratorAction();
  isLayerButton ? showSizeConfiguratorFromLayerAction(true) : showSizeConfiguratorAction();
  showSecondLayerAction();
}

export function onOpenVehicleConfiguratorClick() {
  hideSizeConfiguratorAction();
  hideRegoLookupAction();
  showVehicleConfiguratorAction();
}

export function onOpenVehicleConfiguratorV2Click(fromTyreSize) {
  hideSizeConfiguratorAction();
  hideRegoLookupAction();
  showVehicleConfiguratorActionV2(fromTyreSize);
}

export function onOpenVehicleConfiguratorLayerClick() {
  hideSizeConfiguratorAction();
  hideRegoLookupAction();
  showVehicleConfiguratorFromConfiguratorLayerAction();
}

export function onOpenRegoLookupClick() {
  hideVehicleConfiguratorAction();
  hideSizeConfiguratorAction();
  showRegoLookupAction();
}

export function onOpenRegoLookupV2Click(fromTyreSize) {
  hideVehicleConfiguratorAction();
  hideSizeConfiguratorAction();
  showRegoLookupActionV2(fromTyreSize);
}

export function onOpenRegoLookupConfiguratorLayerClick() {
  hideVehicleConfiguratorAction();
  hideSizeConfiguratorAction();
  showFromConfiguratorAction();
}

export function closeAllConfiguratorLayerClick() {
  hideVehicleConfiguratorAction();
  hideSizeConfiguratorAction();
  hideRegoLookupAction();
}

export function resetConfiguratorData() {
  loadVehicleConfiguratorData();
  loadVehicleConfiguratorMake();
  hideVNPVehicleAction();
  hideVNPRegoAction();
  resetRegoAction();
  resetVehicleAction();
  closeAllConfiguratorLayerClick();
}
